<script>
export default {
  name: "Expandable",
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isExpanded: true
    }
  },
  methods: {
    expand() {
      this.isExpanded = !this.isExpanded
    }
  },
  computed: {
    caret() {
      return this.isExpanded ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-right'
    }
  }
}
</script>

<template>
  <div class="container">
    <div class="header"
         @click.prevent="expand">
      <div class="icon">
        <font-awesome-icon v-bind:icon="caret"/>
      </div>

      <h2>
        {{ title }}
      </h2>
    </div>

    <div class="content"
         v-if="isExpanded">
      <slot/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 0 0.75rem 0;
  padding: 0;
  border-radius: 0.5rem;
  box-shadow: $filtersShadow;
  max-width: none;
}

.header {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  align-content: center;
  user-select: none;
  cursor: pointer;
  background-color: rgba(27, 99, 200, 0.63);
  border-radius: 0.5rem 0.5rem 0 0;
  padding: 0 1rem;
  color: white;

  h2 {
    font-size: 24px;
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border-radius: 0 0 0.5rem 0.5rem;
}

.icon {
  display: inline-flex;
  width: 16px;
  height: 16px;
}
</style>